import axiosClient, {
  getApiErrorMessage,
} from '../api/axiosClient';

// Normalizes the nested JSON API response used by the Laravel backend.
function getResponseData(response) {
  return response?.data?.data ?? response?.data ?? {};
}

// Returns all legal pages and the HTML tags allowed by the backend sanitizer.
export async function getLegalPages() {
  try {
    const response = await axiosClient.get('/legal-pages');
    const data = getResponseData(response);

    return {
      pages: Array.isArray(data?.pages) ? data.pages : [],
      allowedHtmlTags: Array.isArray(data?.allowed_html_tags)
        ? data.allowed_html_tags
        : [],
    };
  } catch (error) {
    throw new Error(getApiErrorMessage(error));
  }
}

// Saves all translated HTML blocks for one legal page.
export async function updateLegalPage(slug, payload) {
  try {
    const response = await axiosClient.put(
      `/legal-pages/${encodeURIComponent(slug)}`,
      payload,
    );
    const data = getResponseData(response);

    return {
      page: data?.page || null,
      message:
        response?.data?.message ||
        'Legal page saved successfully.',
    };
  } catch (error) {
    throw new Error(getApiErrorMessage(error));
  }
}

// Loads one public legal page in the selected interface language.
export async function getPublicLegalPage(slug, locale) {
  try {
    const response = await axiosClient.get(
      `/public/legal-pages/${encodeURIComponent(slug)}`,
      {
        params: {
          locale,
        },
      },
    );

    return getResponseData(response);
  } catch (error) {
    throw new Error(getApiErrorMessage(error));
  }
}
